import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Box, Logo } from '@clariness/clarikit-react';
import { logout } from 'utils/auth';
import { Routing } from 'global/routing';
import { Store } from 'store';
import { captureEventV2 } from 'utils/events/captureEvent';
import { Events } from '@clariness/tracking-event-runtime';
import { useSocket } from 'utils/websocket/WebsocketContext';
import { NavBar } from './components';
import {
  QuestionmarkIcon,
  UserIcon,
  ExportIcon,
  HospitalIcon,
} from '@clariness/clarikit-icons';

export const Header: React.FC = () => {
  const { user } = Store.useUser();
  const { socket, message } = useSocket();
  const intl = useIntl();

  useEffect(() => {
    if (socket) {
      socket.emit('joinDomain', { email: user?.email });
    }
    if (message) {
      console.log('New message:', message);
    }
  }, [user, socket, message]);

  return (
    <Box
      as="header"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap="16px"
      paddingY="15px"
      paddingX={{ _: '16px', md: '40px', lg: '80px', xlg: '110px' }}
      style={{ boxShadow: '1px 0 2px rgba(0, 0, 0, 0.6)' }}
    >
      <RouterLink
        to={Routing.HOME.getPath()}
        data-testid="logo"
        style={{ flexShrink: 0 }}
      >
        <Logo brand="clinLife" size="sm" accessibilityLabel="ClinLife" />
      </RouterLink>

      <NavBar>
        <NavBar.Link
          onClick={() =>
            captureEventV2(
              Events.InvestigatorService.InvestigatorAskHelp({
                InvestigatorID: user?.id ?? '',
              })
            )
          }
          to={Routing.HELP_CENTER.getPath()}
          icon={QuestionmarkIcon}
          label={intl.formatMessage({
            id: 'is.nav_bar.help',
            defaultMessage: 'Help',
          })}
        />

        <NavBar.Divider />

        <NavBar.Link
          onClick={() => {
            captureEventV2(
              Events.InvestigatorService.InvestigatorChecksAccount({
                InvestigatorID: user?.id ?? '',
              })
            );
          }}
          to={Routing.ACCOUNT.getPath()}
          icon={UserIcon}
          label={intl.formatMessage({
            id: 'is.nav_bar.account',
            defaultMessage: 'Account',
          })}
        />

        <NavBar.Divider />

        <NavBar.Link
          to={Routing.MY_SITES.getPath()}
          icon={HospitalIcon}
          label={intl.formatMessage({
            id: 'is.sites_link',
            defaultMessage: 'My Sites',
          })}
        />

        <NavBar.Divider />

        <NavBar.ActionLink
          url={Routing.LOGIN.getPath()}
          onClick={() => {
            captureEventV2(
              Events.InvestigatorService.InvestigatorLogout({
                InvestigatorID: user?.id ?? '',
              })
            );
            logout();
          }}
          icon={ExportIcon}
          label={intl.formatMessage({
            id: 'is.nav_bar.logout',
            defaultMessage: 'Logout',
          })}
        />
      </NavBar>
    </Box>
  );
};
